import CaretDownRegular from "@phosphor-icons/core/assets/regular/caret-down.svg?raw";
import CheckRegular from "@phosphor-icons/core/assets/regular/check.svg?raw";
import CircleHalfRegular from "@phosphor-icons/core/assets/regular/circle-half.svg?raw";
import ListRegular from "@phosphor-icons/core/assets/regular/list.svg?raw";
import MoonRegular from "@phosphor-icons/core/assets/regular/moon.svg?raw";
import SunRegular from "@phosphor-icons/core/assets/regular/sun.svg?raw";
import CodeRegular from "@phosphor-icons/core/assets/regular/code.svg?raw";
import BookOpenTextRegular from "@phosphor-icons/core/assets/regular/book-open-text.svg?raw";
import CursorClickRegular from "@phosphor-icons/core/assets/regular/cursor-click.svg?raw";
import GearSixRegular from "@phosphor-icons/core/assets/regular/gear-six.svg?raw";
import NutRegular from "@phosphor-icons/core/assets/regular/nut.svg?raw";
import ScrewdriverRegular from "@phosphor-icons/core/assets/regular/screwdriver.svg?raw";
import SparkleRegular from "@phosphor-icons/core/assets/regular/sparkle.svg?raw";
import TerminalWindowRegular from "@phosphor-icons/core/assets/regular/terminal-window.svg?raw";
import WrenchRegular from "@phosphor-icons/core/assets/regular/wrench.svg?raw";
import CopyRegular from "@phosphor-icons/core/assets/regular/copy.svg?raw";
import EyeRegular from "@phosphor-icons/core/assets/regular/eye.svg?raw";
import ArrowSquareOutRegular from "@phosphor-icons/core/assets/regular/arrow-square-out.svg?raw";
import SplitHorizontalRegular from "@phosphor-icons/core/assets/regular/split-horizontal.svg?raw";
import SquareHalfRegular from "@phosphor-icons/core/assets/regular/square-half.svg?raw";
import SquareSplitHorizontalRegular from "@phosphor-icons/core/assets/regular/square-split-horizontal.svg?raw";
import FileRegular from "@phosphor-icons/core/assets/regular/file.svg?raw";
import MarkdownLogoRegular from "@phosphor-icons/core/assets/regular/markdown-logo.svg?raw";
import XRegular from "@phosphor-icons/core/assets/regular/x.svg?raw";
import CaretDownDuotone from "@phosphor-icons/core/assets/duotone/caret-down-duotone.svg?raw";
import CheckDuotone from "@phosphor-icons/core/assets/duotone/check-duotone.svg?raw";
import CircleHalfDuotone from "@phosphor-icons/core/assets/duotone/circle-half-duotone.svg?raw";
import ListDuotone from "@phosphor-icons/core/assets/duotone/list-duotone.svg?raw";
import MoonDuotone from "@phosphor-icons/core/assets/duotone/moon-duotone.svg?raw";
import SunDuotone from "@phosphor-icons/core/assets/duotone/sun-duotone.svg?raw";
import CodeDuotone from "@phosphor-icons/core/assets/duotone/code-duotone.svg?raw";
import BookOpenTextDuotone from "@phosphor-icons/core/assets/duotone/book-open-text-duotone.svg?raw";
import CursorClickDuotone from "@phosphor-icons/core/assets/duotone/cursor-click-duotone.svg?raw";
import GearSixDuotone from "@phosphor-icons/core/assets/duotone/gear-six-duotone.svg?raw";
import NutDuotone from "@phosphor-icons/core/assets/duotone/nut-duotone.svg?raw";
import ScrewdriverDuotone from "@phosphor-icons/core/assets/duotone/screwdriver-duotone.svg?raw";
import SparkleDuotone from "@phosphor-icons/core/assets/duotone/sparkle-duotone.svg?raw";
import TerminalWindowDuotone from "@phosphor-icons/core/assets/duotone/terminal-window-duotone.svg?raw";
import WrenchDuotone from "@phosphor-icons/core/assets/duotone/wrench-duotone.svg?raw";
import CopyDuotone from "@phosphor-icons/core/assets/duotone/copy-duotone.svg?raw";
import EyeDuotone from "@phosphor-icons/core/assets/duotone/eye-duotone.svg?raw";
import ArrowSquareOutDuotone from "@phosphor-icons/core/assets/duotone/arrow-square-out-duotone.svg?raw";
import SplitHorizontalDuotone from "@phosphor-icons/core/assets/duotone/split-horizontal-duotone.svg?raw";
import SquareHalfDuotone from "@phosphor-icons/core/assets/duotone/square-half-duotone.svg?raw";
import SquareSplitHorizontalDuotone from "@phosphor-icons/core/assets/duotone/square-split-horizontal-duotone.svg?raw";
import FileDuotone from "@phosphor-icons/core/assets/duotone/file-duotone.svg?raw";
import MarkdownLogoDuotone from "@phosphor-icons/core/assets/duotone/markdown-logo-duotone.svg?raw";
import XDuotone from "@phosphor-icons/core/assets/duotone/x-duotone.svg?raw";

export const phosphorIcons = {
  "caret-down": CaretDownRegular,
  check: CheckRegular,
  "circle-half": CircleHalfRegular,
  list: ListRegular,
  moon: MoonRegular,
  sun: SunRegular,
  code: CodeRegular,
  "book-open-text": BookOpenTextRegular,
  "cursor-click": CursorClickRegular,
  "gear-six": GearSixRegular,
  nut: NutRegular,
  screwdriver: ScrewdriverRegular,
  sparkle: SparkleRegular,
  "terminal-window": TerminalWindowRegular,
  wrench: WrenchRegular,
  copy: CopyRegular,
  eye: EyeRegular,
  "arrow-square-out": ArrowSquareOutRegular,
  "split-horizontal": SplitHorizontalRegular,
  "square-half": SquareHalfRegular,
  "square-split-horizontal": SquareSplitHorizontalRegular,
  file: FileRegular,
  "markdown-logo": MarkdownLogoRegular,
  x: XRegular,
} as const;

const phosphorDuotoneIcons = {
  "caret-down": CaretDownDuotone,
  check: CheckDuotone,
  "circle-half": CircleHalfDuotone,
  list: ListDuotone,
  moon: MoonDuotone,
  sun: SunDuotone,
  code: CodeDuotone,
  "book-open-text": BookOpenTextDuotone,
  "cursor-click": CursorClickDuotone,
  "gear-six": GearSixDuotone,
  nut: NutDuotone,
  screwdriver: ScrewdriverDuotone,
  sparkle: SparkleDuotone,
  "terminal-window": TerminalWindowDuotone,
  wrench: WrenchDuotone,
  copy: CopyDuotone,
  eye: EyeDuotone,
  "arrow-square-out": ArrowSquareOutDuotone,
  "split-horizontal": SplitHorizontalDuotone,
  "square-half": SquareHalfDuotone,
  "square-split-horizontal": SquareSplitHorizontalDuotone,
  file: FileDuotone,
  "markdown-logo": MarkdownLogoDuotone,
  x: XDuotone,
} as const;

export type PhosphorIconName = keyof typeof phosphorIcons;
export type PhosphorIconWeight = "regular" | "duotone";

export interface PhosphorIconState {
  weight?: PhosphorIconWeight | null;
  selected?: unknown;
  active?: unknown;
  pressed?: unknown;
  current?: unknown;
}

const iconifyApiBase = "https://api.iconify.design";
const iconCache = new Map<string, Promise<string>>();

function stateEnabled(value: unknown): boolean {
  return value === true || value === "" || value === "true" || value === "page" || value === "step";
}

function toKebabCase(value: string): string {
  return value
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .toLowerCase();
}

function normalizeIconSet(value: string): string {
  const iconSet = toKebabCase(value);
  if (iconSet === "phosphor" || iconSet === "phosphor-icons") return "ph";
  return iconSet;
}

export function normalizePhosphorIconName(name: string): string {
  const raw = name.trim();
  const separator = raw.indexOf(":");
  return toKebabCase(separator >= 0 ? raw.slice(separator + 1) : raw);
}

function isPhosphorIconSpec(name: string): boolean {
  const raw = name.trim();
  const separator = raw.indexOf(":");
  return separator < 0 || normalizeIconSet(raw.slice(0, separator)) === "ph";
}

export function resolveIconifyIcon(
  name: string,
  state: PhosphorIconWeight | PhosphorIconState = "regular",
): { prefix: string; name: string } | null {
  const raw = name.trim();
  if (
    !raw ||
    raw.includes("/") ||
    raw.includes("\\") ||
    raw.startsWith(".") ||
    raw.startsWith("http:") ||
    raw.startsWith("https:")
  )
    return null;
  const separator = raw.indexOf(":");
  const prefix = separator >= 0 ? normalizeIconSet(raw.slice(0, separator)) : "ph";
  let iconName = toKebabCase(separator >= 0 ? raw.slice(separator + 1) : raw);
  if (!prefix || !iconName || !/^[a-z0-9-]+$/.test(prefix) || !/^[a-z0-9-]+$/.test(iconName))
    return null;
  if (
    prefix === "ph" &&
    resolvePhosphorIconWeight(state) === "duotone" &&
    !iconName.endsWith("-duotone")
  ) {
    iconName = `${iconName}-duotone`;
  }
  return { prefix, name: iconName };
}

export function resolvePhosphorIconWeight(
  state: PhosphorIconWeight | PhosphorIconState = "regular",
): PhosphorIconWeight {
  if (typeof state === "string") return state;
  if (state.weight) return state.weight;
  return stateEnabled(state.selected) ||
    stateEnabled(state.active) ||
    stateEnabled(state.pressed) ||
    stateEnabled(state.current)
    ? "duotone"
    : "regular";
}

export function getPhosphorIcon(
  name: string,
  state: PhosphorIconWeight | PhosphorIconState = "regular",
): string {
  if (!isPhosphorIconSpec(name)) return "";
  const key = normalizePhosphorIconName(name) as PhosphorIconName;
  const regular = phosphorIcons[key] ?? "";
  if (resolvePhosphorIconWeight(state) === "duotone") return phosphorDuotoneIcons[key] ?? regular;
  return regular;
}

export function iconCacheKey(
  name: string,
  state: PhosphorIconWeight | PhosphorIconState = "regular",
): string {
  const resolved = resolveIconifyIcon(name, state);
  return resolved ? `${resolved.prefix}:${resolved.name}` : "";
}

export function iconifySvgUrl(
  name: string,
  state: PhosphorIconWeight | PhosphorIconState = "regular",
): string {
  const resolved = resolveIconifyIcon(name, state);
  if (!resolved) return "";
  return `${iconifyApiBase}/${resolved.prefix}/${resolved.name}.svg?width=1em&height=1em`;
}

function sanitizeIconSvg(svg: string): string {
  const trimmed = svg.trim();
  if (!/^<svg[\s>]/i.test(trimmed) || !/<\/svg>$/i.test(trimmed)) return "";
  if (/<(?:script|foreignObject|iframe|object|embed|link|style)\b/i.test(trimmed)) return "";
  if (/\son[a-z]+\s*=/i.test(trimmed)) return "";
  if (/(?:href|xlink:href)\s*=\s*["']\s*javascript:/i.test(trimmed)) return "";
  return trimmed;
}

async function fetchIconSvg(url: string): Promise<string> {
  if (!url || typeof fetch !== "function") return "";
  try {
    const response = await fetch(url, { credentials: "omit", cache: "force-cache" });
    if (!response.ok) return "";
    return sanitizeIconSvg(await response.text());
  } catch {
    return "";
  }
}

export async function loadPhosphorIcon(
  name: string,
  state: PhosphorIconWeight | PhosphorIconState = "regular",
): Promise<string> {
  const local = getPhosphorIcon(name, state);
  if (local) return local;
  const key = iconCacheKey(name, state);
  const url = iconifySvgUrl(name, state);
  if (!key || !url) return "";
  let pending = iconCache.get(key);
  if (!pending) {
    pending = fetchIconSvg(url);
    iconCache.set(key, pending);
  }
  return pending;
}
